import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  path = '',
  image = 'https://customer-assets.emergentagent.com/job_flexible-families/artifacts/d41tdoag_my-project-page-1.png'
}) => {
  const siteUrl = 'https://www.aupairshare.co.za';
  const fullUrl = `${siteUrl}${path}`;
  const fullTitle = title ? `${title} | Au Pair Share` : 'Au Pair Share | Flexible Childcare in South Africa';
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullUrl} />
      
      {/* Open Graph */}
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
